// activate debug logging by adding cookie in browser:
// document.cookie="debug=true"
const debugCookieExists = () => document.cookie.indexOf('debug=true') >= 0;

export const trace =
    import.meta.env.DEV || debugCookieExists()
        ? // biome-ignore lint/suspicious/noExplicitAny: suppressed out of convenience during migration to biome
          (...args: any) => {
              if (import.meta.env.MODE !== 'test') {
                  console.log('[trace]', ...args);
              }
          }
        : () => {};
